import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path, find, propEq } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import {
  getHistoryPosition,
  getHistoryStatus,
  getHistoryCreated,
  getHistoryUpdated,
  getHistoryView,
  getHistory,
  fetchTaskById,
} from '../../api/task';
import Preloader from "../../common/Preloader";
import { bindFieldAndData } from '../Task/data';

export class TaskLogs extends Component {

  constructor(props) {
    super(props);
    this.build = this.build.bind(this);
  }

  state = {
    loading: true
  };

  componentDidUpdate() {
    const historyUpdated = path([ 'tasks', 'historyUpdated' ], this.props);
    const { loading } = this.state;
    if ( loading && historyUpdated ) {
      this.setState({ loading: false });
    }
  }
  componentWillMount() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.taskHistory(id);
    this.props.getDataById(id);
  }

  build() {
    const arrResult = [];
    const historyUpdated = path(['tasks', 'historyUpdated'], this.props) || null;

    if (historyUpdated) {
      let parsed = JSON.parse(historyUpdated);
      if (parsed && parsed.data) {
        for (let i = 0; i < parsed.data.length; i++) {
          arrResult.push(
            <div key={i} dangerouslySetInnerHTML={{ __html: parsed.data[i].html }}></div>
          );
        }
      }
    }

    return arrResult;
  }

  render() {
    const id = path(['match', 'params', 'id'], this.props);

    const fields = path(['tasks', 'current', 'fields'], this.props);
    const fields_detail = path(['tasks', 'current', 'fields_detail'], this.props);
    let taskLabel = 'Task';

    if (fields && fields_detail) {
      const data = bindFieldAndData(fields, fields_detail);
      const woField = find(propEq('label', 'Work Order'), data);
      if (woField && woField.content) {
        taskLabel = `Task ${woField.content}`;
      }
    }

    const {loading} = this.state;
    const mainPart = loading ? <Preloader show={true} type='circle'/> : this.build();
    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
         { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
         { url: '/pages/task/' + id, icon: 'library_books', name: taskLabel },
         { icon: 'mode_comment', name: 'Logs' },
        ]} />
        <div>{mainPart}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDataById: (id) => {
      fetchTaskById(id)(dispatch);
    },
    taskHistory: (id) => {
      getHistory(id)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskLogs);



// WEBPACK FOOTER //
// ./src/containers/TaskLogs/index.js